import { toast } from "react-toastify";
import {
  TRAIN_FILTERS_CHANGE,
  TRAIN_FILTERS_RESET,
  TRAIN_FILTERS_UPDATE,
  TRAIN_SEARCH_FORM_CHANGE,
  TRAIN_SEARCH_FORM_RESET,
  TRAIN_SEARCH_FORM_UPDATE,
  TRAIN_SEARCH_RESULTS_CHANGE,
  TRAIN_SEARCH_RESULTS_IDLE,
  TRAIN_SEARCH_RESULTS_LOADING,
  TRAIN_SEARCH_RESULTS_RESET,
  TRAIN_SEARCH_RESULTS_UPDATE,
  TRAIN_SINGLE_FILTER_RESET,
} from "./types";
import { ferriesErrorMsgs } from "../../errors";
import { storeSearchSessionMetadata } from "../../api";
import _ from "lodash";
import { searchRequestTrains } from "../../api/trains";

// ==================== TRAIN SEARCH FORM ========================
export const trainSearchFormUpdate = ({ form }) => {
  return { type: TRAIN_SEARCH_FORM_UPDATE, form };
};

export const trainSearchFormChange = (key, value) => {
  return { type: TRAIN_SEARCH_FORM_CHANGE, key, value };
};

export const trainSearchFormReset = () => {
  return { type: TRAIN_SEARCH_FORM_RESET };
};

// ================= TRAIN SEARCH RESULTS ========================
export const trainSearchResultsLoading = () => {
  return { type: TRAIN_SEARCH_RESULTS_LOADING };
};

export const trainSearchResultsIdle = () => {
  return { type: TRAIN_SEARCH_RESULTS_IDLE };
};

export const trainSearchResultsChange = (key, value) => {
  return { type: TRAIN_SEARCH_RESULTS_CHANGE, key, value };
};

export const trainSearchResultsUpdate = (results) => {
  return { type: TRAIN_SEARCH_RESULTS_UPDATE, results };
};

export const trainSearchResultsReset = () => {
  return { type: TRAIN_SEARCH_RESULTS_RESET };
};

export const trainSearchResultsFailed = () => {
  return { type: TRAIN_SEARCH_RESULTS_CHANGE, key: "failed", value: true };
};

// ===================== TRAIN FILTERS  ==========================
export const trainFiltersReset = () => {
  return { type: TRAIN_FILTERS_RESET };
};

export const trainSingleFilterReset = (key) => {
  return { type: TRAIN_SINGLE_FILTER_RESET, key };
};

export const trainFiltersChange = (key, value) => {
  return { type: TRAIN_FILTERS_CHANGE, key, value };
};

export const trainFiltersUpdate = (filters) => {
  return { type: TRAIN_FILTERS_UPDATE, filters };
};

// ===============================================================

function getTrainsSearchPayload({ form }) {
  var traveler_ages = [
    ...form.adults_ages,
    ...form.seniors_ages,
    ...form.youths_ages,
  ];
  var paylaod = {
    market_type: "B2B",
    legs: [
      {
        origin: {
          type_: form.origin.type,
          code: form.origin.code,
        },
        destination: {
          type_: form.destination.type,
          code: form.destination.code,
        },
        departure: form.departDateTime, //"2023-06-16T12:35:00",
        direct_only: false,
      },
    ],
    traveler_ages,
  };
  return paylaod;
}

function actionFailed({ history, dispatch, setLoadingSearchBtn, errorMsg }) {
  dispatch(trainSearchResultsIdle());
  dispatch(trainSearchResultsFailed());
  if (setLoadingSearchBtn) {
    setLoadingSearchBtn(false);
  }
  toast.warning(errorMsg, {
    duration: 3000,
  });
  history.push("/");
}

export const trainsSearchRequest =
  ({ history, setLoadingSearchBtn }) =>
  async (dispatch, getState) => {
    const state = getState();
    const search_form = state.TrainSearchForm;

    dispatch(trainSearchResultsLoading());
    history.push("/trains/");

    const paylaod = getTrainsSearchPayload({
      form: search_form,
    });
    dispatch(trainSearchFormChange("searchPayload", paylaod));
    const results = await searchRequestTrains({
      paylaod,
    });

    if (_.isEmpty(results) || !results.session_id) {
      actionFailed({
        history,
        dispatch,
        setLoadingSearchBtn,
        errorMsg: ferriesErrorMsgs.searchForm.init_search,
      });
      return;
    }

    const search_session_id = _.get(results, "session_id", "");

    const searchSessionMetaResult = await storeSearchSessionMetadata({
      service_type: "TRA",
      session_data: {
        search_session_id,
        search_form: { ...search_form, searchPayload: paylaod },
      },
    });

    if (
      _.isEmpty(_.get(searchSessionMetaResult, "session_data", {})) ||
      !searchSessionMetaResult.session_id
    ) {
      actionFailed({
        history,
        dispatch,
        setLoadingSearchBtn,
        errorMsg: ferriesErrorMsgs.searchForm.no_session,
      });

      return;
    }

    const { session_id: page_session_id } = searchSessionMetaResult;

    dispatch(
      trainSearchResultsUpdate({
        page_session_id,
        search_session_id,
        trains: results.pre_results,
        search_timestamp: results.timestamp,
        loading: false,
      })
    );

    if (setLoadingSearchBtn) {
      setLoadingSearchBtn(false);
    }

    history.push(`/trains/${page_session_id}`);
  };
